import { __read } from "tslib";
import * as u from './urx';
import { listStateSystem } from './listStateSystem';
import { domIOSystem } from './domIOSystem';
export var totalListHeightSystem = u.system(function (_a) {
    var _b = __read(_a, 2), _c = _b[0], footerHeight = _c.footerHeight, headerHeight = _c.headerHeight, fixedHeaderHeight = _c.fixedHeaderHeight, fixedFooterHeight = _c.fixedFooterHeight, listState = _b[1].listState;
    var totalListHeightChanged = u.stream();
    var totalListHeight = u.statefulStreamFromEmitter(u.pipe(u.combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState), u.map(function (_a) {
        var _b = __read(_a, 5), footerHeight = _b[0], fixedFooterHeight = _b[1], headerHeight = _b[2], fixedHeaderHeight = _b[3], listState = _b[4];
        return footerHeight + fixedFooterHeight + headerHeight + fixedHeaderHeight + listState.offsetBottom + listState.bottom;
    })), 0);
    u.connect(u.duc(totalListHeight), totalListHeightChanged);
    return { totalListHeight: totalListHeight, totalListHeightChanged: totalListHeightChanged };
}, u.tup(domIOSystem, listStateSystem), { singleton: true });
